import React from "react";
import MenuBar from "../../components/MenuBar";
import HeaderBar from "../../components/HeaderBar";

export default function PayrollAttendanceAuditNote() {
  return (
    <div className="min-h-screen bg-slate-100/90">
      <MenuBar />
      <HeaderBar />
      <main className="mx-auto max-w-2xl px-4 py-6">
        <p className="text-[10px] font-bold uppercase tracking-wider text-indigo-600">Payroll · Reports</p>
        <h1 className="text-2xl font-bold text-slate-900">Attendance audit log</h1>
        <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-5 text-sm text-amber-950">
          <p className="font-semibold">Not available in the app yet</p>
          <p className="mt-2 leading-relaxed">
            A full audit trail (who exported or approved daily hours) requires writing approval metadata to Firestore or
            Cloud Functions logging when those actions occur. The Daily hours screen can store per-day approvals; use that
            data in Firestore for compliance reviews until a dedicated log viewer is added.
          </p>
        </div>
      </main>
    </div>
  );
}
